import {
  IGamePreviewFeature,
  PreviewFeatureEvaluationResult,
  PreviewFeatureType
} from './game-preview-feature.interface';
import {GameInfo} from '../../games/game-info';
import {IServiceFactory} from '../../service-factory.interface';
import {Check} from '@sparkware/app-utils';

export class MoneyGamePreviewFeature implements IGamePreviewFeature {
  constructor(private _name: string, private _title: string, private _valueEvaluator: (gameInfo: GameInfo) => any, private _shouldRenderWhenEmpty=true) {
  }

  get name(): string {
    return this._name;
  }

  private _extractValue(services: IServiceFactory, gameInfo: GameInfo) {
    let value = parseInt(this._valueEvaluator(gameInfo));
    if(Check.isNumber(value)) {
      return services.currency.formatMoney(value, true)
    } else {
      return null;
    }
  }

  evaluate(services: IServiceFactory, gameInfo: GameInfo): PreviewFeatureEvaluationResult {
    const value = this._extractValue(services, gameInfo);
    if(Check.isEmpty(value) && !this._shouldRenderWhenEmpty){
      return null;
    }

    return {
      title: services.translation.translate(this._title),
      value: this._extractValue(services, gameInfo),
      type: PreviewFeatureType.description
    }
  }
}



